export const PAGE_OPTIONS = [
  { value: "education", label: "Education" },
  { value: "rural", label: "Rural" },
  { value: "urban", label: "Urban" },
  { value: "research", label: "Research" },
  { value: "climate", label: "Climate" },
  { value: "cso", label: "CSO" },
  { value: "circular_economy", label: "Circular Economy" }
];